import LocalFile from './localFile';
import RemoteFile from './remoteFile';
import BlobFile from './blobFile';
export * from './filehandle';
function fromUrl(source) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new RemoteFile(source, opts);
}
function open(maybeUrl, maybePath, maybeFilehandle) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (maybeFilehandle !== undefined) {
    return maybeFilehandle;
  }
  if (maybeUrl !== undefined) {
    return fromUrl(maybeUrl, opts);
  }
  if (maybePath !== undefined) {
    return new LocalFile(maybePath, opts);
  }
  throw new Error('no url, path, or filehandle provided, cannot open');
}
export { open, fromUrl, RemoteFile, LocalFile, BlobFile };